import React, { useState } from 'react'
import AllVideosList from '../lists/AllVideosList';
import ProgramList from '../lists/ProgramList';
import NewAdminProgramForm from '../components/NewAdminProgramForm';
import InputModal from '../components/InputModal';
import { useAdminActions } from '../hooks/useAdminActions';
import VideoPlayerDialog from '../components/VideoPlayerDialog';
import CreateNewFolderIcon from '@mui/icons-material/CreateNewFolder';
import IconButton from "@mui/material/IconButton";
import AddIcon from '@mui/icons-material/Add';
import { Tooltip } from "@mui/material";
import ClearIcon from '@mui/icons-material/Clear';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import NewProgramExerciseForm from '../components/NewProgramExerciseForm';
import SearchInput from '../components/SearchInput';
import { setCopiedExerciseId } from '../context/copiedExerciseSlice';
import { useSelector, useDispatch } from 'react-redux';


export default function ProgramAdmin({ handleChangeAppbarTitle }) {
    const [showNewProgramModal, setShowNewProgramModal] = useState(false)
    const [showNewExerciseModal, setShowNewExerciseModal] = useState(false)
    const [showEditExerciseModal, setShowEditExerciseModal] = useState(false)
    const [showVideoPlayer, setShowVideoPlayer] = useState(false)
    const [exerciseId, setExerciseId] = useState('')
    const [videoTitle, setVideoTitle] = useState('')
    const [visibleDelete, setVisibleDelete] = useState(false);
    const [existingItem, setExistingItem] = useState(null)
    const [searchVideoString, setSearchVideoString] = useState('')
    const [searchProgString, setSearchProgString] = useState('')

    const { newAdminProgram, addProgramExercise, editProgramExercise, deleteUserProgram, pasteProgramExercise } = useAdminActions()
   
    const dispatch = useDispatch();
    const copiedExerciseId = useSelector((state) => state.copiedExercise.id);

    const handleCloseModal = () => {
        setShowNewProgramModal(false)
        setShowVideoPlayer(false)
        setShowNewExerciseModal(false)
        setShowEditExerciseModal(false)
    }

    const handleShowNewExerciseModal = () => {
        setShowNewExerciseModal(true)
    }

    const handleShowNewProgramModal = () => {
        setShowNewProgramModal(true)
    }

    const handleAddAdminProgram = (adminProgram) => {
        newAdminProgram(adminProgram)
        setShowNewProgramModal(false)
    }

    const handleAddProgramExercise = (exercise) => {
        addProgramExercise(exercise)
        setShowNewProgramModal(false)
        setShowNewExerciseModal(false)
    }

    const handleEditProgramExercise = (exercise) => {
        editProgramExercise(exercise)
        setShowNewProgramModal(false)
        setShowEditExerciseModal(false)
    }

    handleChangeAppbarTitle("Programadministrasjon")

    const onContextMenuClick = (node, action) => {
        if (action === 0) {
            handleShowVideoExercise(node)
        } else if (action === 1) {
            handleEditItem(node)
        } else if (action === 2) {
            handleCopyItem(node)
        } else if (action === 3) {
            handlePasteItem(node)
        }
    }

    const handleShowVideoExercise = (node) => {
        setExerciseId(node.id)
        setShowVideoPlayer(true)
    }

    const handleEditItem = (node) => {
        setExistingItem(node)
        setShowEditExerciseModal(true)
    }

    const handleCopyItem = (node) => { 
        dispatch(setCopiedExerciseId(node.id))
    }

    const handlePasteItem = (node) => {
        pasteProgramExercise(copiedExerciseId, node.parent, node.id)
    }

    const handleSetTitle = (title) => {
        setVideoTitle(title)
    }
    const handleClick = () => {
        setVisibleDelete(!visibleDelete)
    }

    const handleDelete = (node) => {
        confirmAlert({
            title: 'Slette program',
            message: 'Er du sikker på at du vil slette ' + node.text + '?',
            buttons: [
                {
                    label: 'OK',
                    onClick: () => deleteUserProgram(node)
                },
                {
                    label: 'Avbryt',
                }
            ]
        });
    };

    const handleVideoSearchString = (searchString) => {
        setSearchVideoString(searchString)
    }

    const handleProgSearchString = (searchString) => {
        setSearchProgString(searchString)
    }

    return (
        <div className='program-admin'>
            <div className='d-flex' >
                <div className='p-2 flex-grow-1 dig-container-leftmargin'
                >
                    <SearchInput handleSearchString={handleProgSearchString} setMargin={15}>
                        <span className="p-1 flex-grow-1"
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                            }}>
                            <h5 style={{ color: 'gray', margin: 20 }}>Programmer</h5>
                            <div style={{
                                margin: 10
                                // backgroundColor: 'whitesmoke',
                                // borderRadius: '8px',
                                // boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)',

                            }}>
                                <Tooltip title="Legg til nytt program">
                                    <IconButton onClick={handleShowNewProgramModal} color="primary" >
                                        <CreateNewFolderIcon />
                                    </IconButton>
                                </Tooltip>

                                <Tooltip title="Legg til ny øvelse">
                                    <IconButton onClick={handleShowNewExerciseModal} color="primary">
                                        <AddIcon />
                                    </IconButton>
                                </Tooltip>

                                <Tooltip title="Slettemodus av/på">
                                    <IconButton onClick={handleClick} color="primary">
                                        <ClearIcon />
                                    </IconButton>
                                </Tooltip>
                            </div>
                        </span>
                    </SearchInput>

                    <div className='program-list'>
                        <ProgramList
                            onContextMenuClick={onContextMenuClick}
                            allowDrop={true}
                            visibleDelete={visibleDelete}
                            handleDelete={handleDelete}
                            showEditMenu={true}
                            searchString={searchProgString}
                        />
                    </div>
                </div>
                <div className='p-2 flex-grow-1 dig-container'
                // style={{
                //     boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)',
                //     borderRadius: '8px',
                //     backgroundColor: 'white',
                // }}
                >
                    <div className='program-list'>
                        <SearchInput handleSearchString={handleVideoSearchString}>
                            <h5 style={{ color: 'gray', margin: 20 }}>Videoøvelser</h5>
                        </SearchInput>
                        <AllVideosList onContextMenuClick={onContextMenuClick} searchString={searchVideoString} />

                    </div>
                </div>
            </div>
            {showNewProgramModal &&
                (<InputModal title="Legg til nytt program" handleCloseModal={handleCloseModal}>
                    <NewAdminProgramForm addAdminProgram={handleAddAdminProgram} />
                </InputModal>)
            }
            {showNewExerciseModal &&
                (<InputModal title="Legg til ny øvelse" handleCloseModal={handleCloseModal}>
                    <NewProgramExerciseForm addProgramExercise={handleAddProgramExercise} />
                </InputModal>)
            }
            {showEditExerciseModal &&
                (<InputModal title="Rediger øvelse" handleCloseModal={handleCloseModal}>
                    <NewProgramExerciseForm addProgramExercise={handleEditProgramExercise} existingItem={existingItem} />
                </InputModal>)
            }
            {showVideoPlayer &&
                (<InputModal title={videoTitle} handleCloseModal={handleCloseModal}>
                    <VideoPlayerDialog exerciseId={exerciseId} handleSetTitle={handleSetTitle} />
                </InputModal>)
            }
        </div>
    )
}
